import {
  setCurrentStoreData,
  setCustomPageName,
  setUpdatedUserData,
  setCustomUserData
} from "../../utils/appDynamics";
   
export const useAppD = () => {
  const setAppDPageName = (page) => {
    setCustomPageName(page);
  };

  const setAppDUserData = (userObj) => {
    setCustomUserData(userObj);
  }

  return {
      setAppDPageName,
      setAppDUserData
  }
}